<h3>{{title}}</h3>

<form [formGroup]="parameterForm" (ngSubmit)="onSubmit()"  *ngIf="!confirm">
  <div class="item_base_and_actions">
    <div class="item_base">
      <mat-form-field appearance="outline" class="item_parameter">
        <mat-label>Label</mat-label>
        <input matInput type="text" formControlName="label" />
      </mat-form-field>

        <mat-form-field appearance="outline" class="item_parameter">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" (selectionChange)="generateControlsValue()">
            <mat-option *ngFor="let t of typeOfInput" [value]="t">{{
              t
            }}</mat-option>
          </mat-select>
        </mat-form-field>

    </div>
  </div>

  <div class="parameter_values" *ngIf="parameterForm.value.type ?  ['valeur min/max' , 'checkbox' , 'liste'].includes(parameterForm.value.type)  : ['valeur min/max' , 'checkbox' , 'liste'].includes(parameterForm.value.typeInput)
    ">
    <div class="parameter_values_title">
      <h5>Indiquez les valeurs</h5>
      <div class="add_value" *ngIf="['liste' , 'checkbox']. includes(parameterForm.value.type)" (click)="addParameterItemValue()" appChangeColorTheme attribute="color">
        <fa-icon [icon]="getFaIcon('faPlus')"></fa-icon>
        <p>Ajouter une valeur</p>
      </div>
    </div>
    <div class="parameter_values_content">
      <div *ngIf="['liste' , 'checkbox']. includes(parameterForm.value.type)" class="parameter_values_item_checkbox_values">
        <div formArrayName="values" *ngFor="let v of getselectionParametersValues()?.controls; let vI = index" class="parameter_values_item">
          <div [formGroup]="v" class="parameter_values_item_formgroup">
            <mat-form-field appearance="outline">
              <mat-label>Valeur {{ vI + 1 }}</mat-label>
              <input matInput type="text" formControlName="valueSelect" />
            </mat-form-field>
            <fa-icon [icon]="getFaIcon('faTimes')" *ngIf="vI > 0 && ['liste' , 'checkbox']. includes(parameterForm.value.type)" (click)="deletedParameterItemValue(vI)"></fa-icon>
          </div>
        </div>
      </div>
      <div *ngIf="parameterForm.value.type === 'valeur min/max'" class="parameter_values_item_min_max">
        <div formArrayName="values" *ngFor="
            let v of getselectionParametersValues()?.controls;
            let vI = index
          " class="parameter_values_item">
          <div [formGroup]="v" class="parameter_values_item_formgroup">
            <mat-form-field appearance="outline" class="minField">
              <mat-label>Min </mat-label>
              <input matInput type="text" formControlName="min" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="maxField">
              <mat-label>Max </mat-label>
              <input matInput type="text" formControlName="max" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="btn_action">
    <button class="back" type="button" (click)="closeDialog()">Annuler</button>
    <button [ngClass]="{not_confirm: parameterForm.invalid, confirm: parameterForm.valid}" type="submit"
      [disabled]="parameterForm.invalid" appChangeColorTheme attribute="bgc" >{{btnConfirm}}</button>
  </div>

</form>

<app-validation-animation [text]="text" *ngIf="confirm" ></app-validation-animation>

